import {
  DeleteOutlineRounded,
  KeyboardDoubleArrowLeftRounded,
  KeyboardDoubleArrowRightRounded,
} from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';

import { useSelectedEpisodesToolbar } from './useSelectedEpisodesToolbar';

export const SelectedEpisodesToolbar = ({
  episodeId,
}: {
  episodeId: string;
}) => {
  const {
    removeEpisode,
    moveEpisodeToDirection,
    isUpdating,
    checkIsMoveToLeftDisabled,
    checkIsMoveToRightDisabled,
  } = useSelectedEpisodesToolbar();

  const isMoveToLeftDisabled = checkIsMoveToLeftDisabled(episodeId);
  const isMoveToRightDisabled = checkIsMoveToRightDisabled(episodeId);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
      <Tooltip title="Swap with Left">
        <IconButton
          disabled={isUpdating || isMoveToLeftDisabled}
          onClick={() =>
            moveEpisodeToDirection({ episodeId, direction: 'left' })
          }>
          <KeyboardDoubleArrowLeftRounded />
        </IconButton>
      </Tooltip>
      <Tooltip title="Remove">
        <IconButton
          disabled={isUpdating}
          onClick={() => removeEpisode(episodeId)}>
          <DeleteOutlineRounded />
        </IconButton>
      </Tooltip>
      <Tooltip title="Swap with Right">
        <IconButton
          disabled={isUpdating || isMoveToRightDisabled}
          onClick={() =>
            moveEpisodeToDirection({ episodeId, direction: 'right' })
          }>
          <KeyboardDoubleArrowRightRounded />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
